import React from 'react';
import PropTypes from 'prop-types';

function Label({
  htmlFor,
  className,
  text,
  showError,
  errorText,
  children,
}) {
  return (
    <label htmlFor={htmlFor} className={`address-input-label ${className} ${showError ? 'address-input-label-error' : ''}`}>
      <span className="label">{text}</span>
      <div className="at-mt-2">
        { children }
        {showError && (
        <div className="at-select__error at-font__body2 at-mt-2 at-align-items-center at-d-flex">
          <svg aria-label="selected" className="at-icon at-me-2"><use href="#icon-missing-tag-off" /></svg>
          {errorText}
        </div>
        )}
      </div>
    </label>
  );
}

Label.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
  showError: PropTypes.bool,
  errorText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Label.defaultProps = {
  className: '',
  text: '',
  showError: false,
  errorText: 'Field is required',
};

export default Label;
